import type { IconData } from '@stacksjs/iconify-core'

export const designRuler: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 1.53H32v7.62h-1.53Zm-19.8 7.62V1.53h1.52v1.52h1.52V1.53h3.05v3.05h1.52V1.53h3.05v1.52h1.53V1.53h3.04v3.05h1.53V1.53h3.04V0H6.09v1.53h3.05v7.62H1.52V6.1H0v24.38h1.52v-3.05h3.05v-1.52H1.52v-3.05h1.53v-1.52H1.52v-3.05h3.05v-1.52H1.52v-3.05h1.53V12.2H1.52v-1.53h7.62v19.81h1.53V10.67h19.8V9.15zM1.52 30.48h7.62V32H1.52Z\"/><path fill=\"currentColor\" d=\"M4.57 1.53h1.52v1.52H4.57ZM3.05 3.05h1.52v1.53H3.05ZM1.52 4.58h1.53V6.1H1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default designRuler
